import React from "react";
import { API_URL } from "../../redux/constants/type";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import { toast } from "react-toastify";
import LogoSmall from "../../assets/images/logo-small.png";
import { ProgressBar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { UpdateFileUploading } from "../../redux/actions/action";

const DocumentUploaderWithProgress = ({
  children,
  onUploaded,
  getFilePreview,
  onFail,
  maxSizeInMb,
  filefilter,
  beforeFileUpload,
}) => {
  const isFileUploading = useSelector((s) => s.user.isFileUploading);
  const dispatch = useDispatch();
  const uploadRef = React.useRef();
  const progressRef = React.useRef();
  const toastIdRef = React.useRef(null);
  const imageInfo = React.useRef({ name: "", size: "", type: "", link: "" });
  const imageInfo2 = React.useRef([{ name: "", size: "", type: "", link: "" }]);

  const UploadFile = () => {
    const { files: selected } = uploadRef.current;
    const files = [...selected];
    const invalidFile = files?.find((item) => !isFileValid(item));
    if (invalidFile) return;
    // const file = uploadRef.current.files[0];
    // if (isFileValid(file)) {
    // getFilePreview && getFilePreview(URL.createObjectURL(file));
    var formData = new FormData();
    files?.map((item) => {
      formData.append("file", item);
    });
    // formData.append("file", file);
    let data = [];
    files?.map((item) => {
      data.push({
        name: item?.name,
        size: item?.size,
        type: item?.name?.split(".").pop(),
        link: "",
      });
    });
    imageInfo2.current = data;

    // imageInfo.current = {
    //   name: file.name,
    //   size: file.size,
    //   type: file.name.split(".").pop(),
    //   link: "",
    // };
    dispatch(UpdateFileUploading(true));
    var xhr = new XMLHttpRequest();
    xhr.upload.addEventListener("progress", ProgressHandler, false);
    xhr.addEventListener("load", SuccessHandler, false);
    xhr.addEventListener("error", ErrorHandler, false);
    xhr.addEventListener("abort", AbortHandler, false);
    xhr.open("POST", `${API_URL}/api/Files/InsertDocToS3`);
    showFileUploadingToast();
    xhr.send(formData);
    // }
  };

  const ProgressHandler = (e) => {
    var percent = (e.loaded / e.total) * 100;
    progressRef.current = percent;
    toast.update(toastIdRef.current, {
      render: <ProgressBarNotification progress={progressRef.current} />,
    });
  };

  const SuccessHandler = (e) => {
    dispatch(UpdateFileUploading(false));
    toast.update(toastIdRef.current, {
      render: (
        <ProgressBarNotification progress={progressRef.current} done={true} />
      ),
      autoClose: 3000,
    });
    if (onUploaded) {
      let data = [...imageInfo2?.current];
      JSON.parse(e.target.responseText)?.map((item, index) => {
        data[index]["link"] = item;
      });
      imageInfo2.current = data;
      imageInfo.current.link = JSON.parse(e.target.responseText)[0];
      onUploaded(imageInfo2.current);
    }
    handleResetFileUploader();
  };

  const ErrorHandler = () => {
    dispatch(UpdateFileUploading(false));
    toast.done(toastIdRef.current);
    handleResetFileUploader();
  };

  const AbortHandler = () => {
    dispatch(UpdateFileUploading(false));
    toast.done(toastIdRef.current);
    handleResetFileUploader();
  };

  const isFileValid = (file) => {
    let isValid = true;
    if (Boolean(maxSizeInMb)) {
      const filesizecontvrt = file.size / 1024;
      if (filesizecontvrt / 1024 > maxSizeInMb) {
        isValid = false;
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: `The file is too big: Upload a file of max ${maxSizeInMb} MB.`,
          },
          false
        );
      }
    }

    if (Boolean(beforeFileUpload) && isValid == true) {
      isValid = beforeFileUpload(file);
    }

    if (!isValid) {
      handleResetFileUploader();
    }
    return isValid;
  };

  const handleResetFileUploader = () => {
    if (uploadRef.current) {
      uploadRef.current.value = "";
      uploadRef.current.type = "text";
      uploadRef.current.type = "file";
    }
    toastIdRef.current = null;
    progressRef.current = 0;
    imageInfo.current.link = "";
    imageInfo.current.name = "";
    imageInfo.current.size = "";
    imageInfo.current.type = "";
    imageInfo2.current = [{ name: "", size: "", type: "", link: "" }];
  };

  const openFileUploader = () => {
    if (!isFileUploading) {
      uploadRef.current?.click();
    }
  };

  const showFileUploadingToast = () => {
    toastIdRef.current = toast(<ProgressBarNotification progress={0} />, {
      icon: () => <img src={LogoSmall} width={35} />,
      className: "app-notification",
      closeButton: true,
      closeOnClick: true,
      autoClose: true,
    });
  };

  return (
    <>
      <input
        type="file"
        ref={uploadRef}
        className="d-none"
        onChange={UploadFile}
        accept={filefilter}
        multiple={true}
      />
      <div onClick={openFileUploader}>{children}</div>
    </>
  );
};

const ProgressBarNotification = ({ progress, done = false }) => {
  return (
    <div className="app-notification-container">
      <div className="d-flex flex-column gap-1">
        <div>
          {done
            ? "Document Uploaded successfully!"
            : "Your document is loading..."}
        </div>
        {!done && (
          <ProgressBar now={progress} className="notification-progress-bar" />
        )}
      </div>
    </div>
  );
};

export default DocumentUploaderWithProgress;
